<template>
  <v-row>
    <v-col cols="12" md="6" class="pr-md-5">
      <BaseFormInput
        id-element="startDate"
        placeholder="DD/MM/YYYY"
        v-model="value.inicio"
        required
        :rules="[requiredInput, dateTermValid]"
        validate-on-blur
        label-text="Data início"
        v-facade="maskDate"
      />
    </v-col>
    <v-col cols="12" md="6">
      <BaseFormInput
        id-element="endDate"
        placeholder="DD/MM/YYYY"
        v-model="value.fim"
        required
        :rules="[requiredInput, dateTermValid]"
        validate-on-blur
        label-text="Data fim"
        v-facade="maskDate"
      />
    </v-col>
    <v-col cols="12" v-if="documents.length == 0" class="pt-3">
      <DropFile v-on="$listeners" />
      <BaseErrorMessages
        v-if="errorMessages.length > 0"
        :error-messages="errorMessages"
      />
    </v-col>
  </v-row>
</template>

<script>
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import DropFile from "@/components/DropFile.vue";

export default {
  props: {
    value: {
      type: Object
    },
    errorMessages: {
      type: Array
    },
    documents: {
      type: Array
    }
  },
  data: () => ({ requiredInput, dateTermValid, maskDate }),
  components: { DropFile }
};
</script>
